import {athubAxios} from "../../../util/athub-axios"
import {ORGANIZATION_SERVER} from '@/api/server'

const positionGrade = {
    page: page,
    add: add,
    update: update,
    remove: remove,
    findById: findById,
    checkName: checkPositionGradeNameAvailable,
    checkCode: checkPositionGradeCodeAvailable,
    positionGradeOptions: positionGradeOptions,
    valid: valid,
    invalid: invalid,
};

export default positionGrade;

/**
 * 条件查询职级列表分页信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function page(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/positionGrade/page`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 检查职级名称是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkPositionGradeNameAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/positionGrade/check/name`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 检查职级编号是否可用
 * @param params
 * @returns true 可用 false不可用
 */
export function checkPositionGradeCodeAvailable(params) {
    return new Promise((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/positionGrade/check/code`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    })
}

/**
 * 获取所有职级options
 */
export function positionGradeOptions() {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/positionGrade/grade/options`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 添加职级信息
 * @param params
 * @returns {Promise<unknown>}
 */
export function add(params) {
    return new Promise(((resolve, reject) => {
        athubAxios.post(`${ORGANIZATION_SERVER}/positionGrade`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            ).catch(err => {
            reject(err);
        })
    }));
}

/**
 * 修改职级信息
 * @param id 职级ID
 * @param params
 * @returns {Promise<unknown>}
 */
export function update(id, params) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/positionGrade/${id}`, params)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 删除职级信息
 * @param id 职级ID
 * @returns {Promise<unknown>}
 */
export function remove(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.delete(`${ORGANIZATION_SERVER}/positionGrade/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 根据职级ID查询职级详情
 * @param id
 * @returns {Promise<unknown>}
 */
export function findById(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.get(`${ORGANIZATION_SERVER}/positionGrade/${id}`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }));
}

/**
 * 启用
 * @param params
 * @returns {Promise<unknown>}
 */
export function valid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/positionGrade/${id}/valid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}

/**
 * 停用
 * @param params
 * @returns {Promise<unknown>}
 */
export function invalid(id) {
    return new Promise(((resolve, reject) => {
        athubAxios.put(`${ORGANIZATION_SERVER}/positionGrade/${id}/invalid`)
            .then(result => {
                    result.status === 200 ? resolve(result) : reject(result)
                }, (error) => {
                    reject(error);
                }
            )
    }))
}